import { useQuery } from '@tanstack/react-query'

import { IProductResponse } from 'src/@interfaces'
import { getConfig } from 'src/helpers'
import { Api, queryConfig, QUERY_DATA } from 'src/service'

import { useMagazineContext } from '../useMagazineContext'
import { useReseller } from '../useReseller/useReseller'

const { businessUnit } = getConfig()

type OrderByParam = 'asc' | 'desc'

interface IOrderBy {
  brand?: OrderByParam
  category?: OrderByParam
  name?: OrderByParam
  ratingCount?: OrderByParam
  ratingValue?: OrderByParam
  sku?: OrderByParam
  subcategory?: OrderByParam
}

export const useProducts = (products: string[], orderBy?: IOrderBy) => {
  const { data: reseller, isGenericUser } = useReseller()

  const magazine = useMagazineContext()

  const getProducts = () => {
    const state = isGenericUser && magazine ? magazine.cycle.state : reseller?.addressHomeState
    const catalogSlug = isGenericUser ? null : reseller?.catalogSlug

    const body = {
      page: 1,
      pageSize: 49,
      businessUnit,
      state,
      skus: products,
      catalogSlug,
      orderBy,
    }

    return Api.post('/product/', body).then((response) => response.data)
  }

  return useQuery<IProductResponse | undefined>(
    [QUERY_DATA.PRODUCTS, products],
    getProducts,
    queryConfig,
  )
}
